/* Generated by scripts/phase-9/track-piece-thumbnail-factory.mjs. Do not edit. */
import type { TrackPieceThumbnailManifestEntry } from '../ui/track-piece-thumbnail-contract.ts';

export const TRACK_PIECE_THUMBNAIL_MANIFEST = [
  {
    descriptorId: 'straight.0_5t',
    url: 'assets/track-piece-thumbnails/straight-0-5t.99fdb45e5d11.webp',
    viewId: 'top',
    width: 384,
    height: 384,
    byteSize: 2336,
    sha256: '99fdb45e5d11df22ad9d929f458cf3fdc2b43ad7002eb30a1dafc6e37077f9bf',
    rendererVersion: 'bc-906-v2',
  },
  {
    descriptorId: 'straight.1t',
    url: 'assets/track-piece-thumbnails/straight-1t.4e3e938402b3.webp',
    viewId: 'top',
    width: 384,
    height: 384,
    byteSize: 2356,
    sha256: '4e3e938402b3c7c524e7f43bdc4530e21d99d7380a1e71041febaa9319a44f96',
    rendererVersion: 'bc-906-v2',
  },
  {
    descriptorId: 'straight.2t',
    url: 'assets/track-piece-thumbnails/straight-2t.4cfb0550af35.webp',
    viewId: 'top',
    width: 384,
    height: 384,
    byteSize: 2446,
    sha256: '4cfb0550af357f699b862bb74604133b913c24044b9811c3c23e31c30087ea89',
    rendererVersion: 'bc-906-v2',
  },
  {
    descriptorId: 'straight.3t',
    url: 'assets/track-piece-thumbnails/straight-3t.fa2a6c1d7c05.webp',
    viewId: 'top',
    width: 384,
    height: 384,
    byteSize: 2518,
    sha256: 'fa2a6c1d7c05240b126c891086ffb62283dcb10d11235ed7637227ee40710c4e',
    rendererVersion: 'bc-906-v2',
  },
  {
    descriptorId: 'slope.0.25',
    url: 'assets/track-piece-thumbnails/slope-0-25.a8a1dd3448c6.webp',
    viewId: 'side',
    width: 384,
    height: 384,
    byteSize: 4060,
    sha256: 'a8a1dd3448c670cdbea36cfbb30147b06c81bd9c665d146293d08d6a92d2cf4f',
    rendererVersion: 'bc-906-v2',
  },
  {
    descriptorId: 'slope.25.60',
    url: 'assets/track-piece-thumbnails/slope-25-60.3453fc8154de.webp',
    viewId: 'side',
    width: 384,
    height: 384,
    byteSize: 5620,
    sha256: '3453fc8154deafdd060cabd550be777fc024ae51594b16e222ea12961be32e97',
    rendererVersion: 'bc-906-v2',
  },
  {
    descriptorId: 'slope.60.90',
    url: 'assets/track-piece-thumbnails/slope-60-90.6f855239bafe.webp',
    viewId: 'side',
    width: 384,
    height: 384,
    byteSize: 3950,
    sha256: '6f855239bafede0419e4ad1215371b67a7a3a2f48d91188917f577f0c5bceeb7',
    rendererVersion: 'bc-906-v2',
  },
  {
    descriptorId: 'slope.90.60',
    url: 'assets/track-piece-thumbnails/slope-90-60.fe03f0d6bf14.webp',
    viewId: 'side',
    width: 384,
    height: 384,
    byteSize: 7448,
    sha256: 'fe03f0d6bf143aa9f05a4e1cc307cf3bdf3163b7c4eb3b1a25c8b34a0217cdbb',
    rendererVersion: 'bc-906-v2',
  },
  {
    descriptorId: 'slope.60.25',
    url: 'assets/track-piece-thumbnails/slope-60-25.ecc9fb011e57.webp',
    viewId: 'side',
    width: 384,
    height: 384,
    byteSize: 5648,
    sha256: 'ecc9fb011e57b3ae1fad126d4e01ae5ab1cd4879b0f2ec794eeb4389f935af9b',
    rendererVersion: 'bc-906-v2',
  },
  {
    descriptorId: 'slope.25.0',
    url: 'assets/track-piece-thumbnails/slope-25-0.d161194d3a75.webp',
    viewId: 'side',
    width: 384,
    height: 384,
    byteSize: 4044,
    sha256: 'd161194d3a757503dd5a7a2c2cc1f9e2f543e6cec11e83c4d99a1e9e1c6eafb3',
    rendererVersion: 'bc-906-v2',
  },
  {
    descriptorId: 'slope.0.n25',
    url: 'assets/track-piece-thumbnails/slope-0-n25.5ec95be4682f.webp',
    viewId: 'side',
    width: 384,
    height: 384,
    byteSize: 3392,
    sha256: '5ec95be4682ff62b95b07f78c850303205aa05f9663253f9f7d5ebe90f4a406b',
    rendererVersion: 'bc-906-v2',
  },
  {
    descriptorId: 'slope.n25.n60',
    url: 'assets/track-piece-thumbnails/slope-n25-n60.4565b039f300.webp',
    viewId: 'side',
    width: 384,
    height: 384,
    byteSize: 4108,
    sha256: '4565b039f300dd5d7f31fbfcafd44cd36ea8a5dce650b23aeec2546e823551a5',
    rendererVersion: 'bc-906-v2',
  },
  {
    descriptorId: 'slope.n60.n90',
    url: 'assets/track-piece-thumbnails/slope-n60-n90.1c81762b1adb.webp',
    viewId: 'side',
    width: 384,
    height: 384,
    byteSize: 3298,
    sha256: '1c81762b1adbad8880fefd73cc9d86ea3f80debd57422509d53fed9527bcf4dd',
    rendererVersion: 'bc-906-v2',
  },
  {
    descriptorId: 'slope.n90.n60',
    url: 'assets/track-piece-thumbnails/slope-n90-n60.c75af57883dd.webp',
    viewId: 'side',
    width: 384,
    height: 384,
    byteSize: 6282,
    sha256: 'c75af57883dd9be161b85fa6de939fab203c600d71cad869521741e11528b7a3',
    rendererVersion: 'bc-906-v2',
  },
  {
    descriptorId: 'slope.n60.n25',
    url: 'assets/track-piece-thumbnails/slope-n60-n25.22817f4f601c.webp',
    viewId: 'side',
    width: 384,
    height: 384,
    byteSize: 4114,
    sha256: '22817f4f601cdb53416b8b46ab68e9720ee28f8af8e7bc034c52ab8825defae6',
    rendererVersion: 'bc-906-v2',
  },
  {
    descriptorId: 'slope.n25.0',
    url: 'assets/track-piece-thumbnails/slope-n25-0.8d8de359ea68.webp',
    viewId: 'side',
    width: 384,
    height: 384,
    byteSize: 3310,
    sha256: '8d8de359ea68fecbc1d671793e69b6dae48826ab2f6f7924a302c53c9094267f',
    rendererVersion: 'bc-906-v2',
  },
  {
    descriptorId: 'slope.25.hold.run0_5t',
    url: 'assets/track-piece-thumbnails/slope-25-hold-run0-5t.7f8295a996e0.webp',
    viewId: 'side',
    width: 384,
    height: 384,
    byteSize: 4522,
    sha256: '7f8295a996e0c968e1e59ec9a404c3740ca14cfa34d589b479c2b2b15f9f60f8',
    rendererVersion: 'bc-906-v2',
  },
  {
    descriptorId: 'slope.25.hold.run1t',
    url: 'assets/track-piece-thumbnails/slope-25-hold-run1t.68ea66271cc5.webp',
    viewId: 'side',
    width: 384,
    height: 384,
    byteSize: 4368,
    sha256: '68ea66271cc5cf6b2ba345f9a56c07d47f8dccfa3549ae661d60745fa56d6fc6',
    rendererVersion: 'bc-906-v2',
  },
  {
    descriptorId: 'slope.25.hold.run2t',
    url: 'assets/track-piece-thumbnails/slope-25-hold-run2t.e9ff80120347.webp',
    viewId: 'side',
    width: 384,
    height: 384,
    byteSize: 4178,
    sha256: 'e9ff80120347ea01ad8c36910fb9ffd3ad98740be315f3c0fec3bd9d36fcfce6',
    rendererVersion: 'bc-906-v2',
  },
  {
    descriptorId: 'slope.25.hold.run3t',
    url: 'assets/track-piece-thumbnails/slope-25-hold-run3t.1c7afbe7153c.webp',
    viewId: 'side',
    width: 384,
    height: 384,
    byteSize: 4106,
    sha256: '1c7afbe7153c3d1d6fe01c8099672ca267d313feb0913175cc9b744607903f02',
    rendererVersion: 'bc-906-v2',
  },
  {
    descriptorId: 'slope.n25.hold.run0_5t',
    url: 'assets/track-piece-thumbnails/slope-n25-hold-run0-5t.e7ab0f337f10.webp',
    viewId: 'side',
    width: 384,
    height: 384,
    byteSize: 3118,
    sha256: 'e7ab0f337f10f348a6ef796a02896b71ad6215d154ef34cad459770d5cbd8141',
    rendererVersion: 'bc-906-v2',
  },
  {
    descriptorId: 'slope.n25.hold.run1t',
    url: 'assets/track-piece-thumbnails/slope-n25-hold-run1t.f360f0da3e10.webp',
    viewId: 'side',
    width: 384,
    height: 384,
    byteSize: 3182,
    sha256: 'f360f0da3e1000cb50b6cbd170dd6e00cf8d636fc195986d1c6f564946ddcc66',
    rendererVersion: 'bc-906-v2',
  },
  {
    descriptorId: 'slope.n25.hold.run2t',
    url: 'assets/track-piece-thumbnails/slope-n25-hold-run2t.9152fa3e0aa5.webp',
    viewId: 'side',
    width: 384,
    height: 384,
    byteSize: 3286,
    sha256: '9152fa3e0aa55e845e33dc8d0f2cfa2235a0c9cfb6f436745d3fa1c753a4b541',
    rendererVersion: 'bc-906-v2',
  },
  {
    descriptorId: 'slope.n25.hold.run3t',
    url: 'assets/track-piece-thumbnails/slope-n25-hold-run3t.8f72a6752d6e.webp',
    viewId: 'side',
    width: 384,
    height: 384,
    byteSize: 3224,
    sha256: '8f72a6752d6eb09a24a8e72a09707ad81072a2d24460e48a3de8ffeae7a04204',
    rendererVersion: 'bc-906-v2',
  },
  {
    descriptorId: 'slope.60.hold.run0_5t',
    url: 'assets/track-piece-thumbnails/slope-60-hold-run0-5t.76208fe2dc0d.webp',
    viewId: 'side',
    width: 384,
    height: 384,
    byteSize: 4394,
    sha256: '76208fe2dc0d7033d87b99b2a9ab10854486d75cca8435ba7493ff42da054bfb',
    rendererVersion: 'bc-906-v2',
  },
  {
    descriptorId: 'slope.60.hold.run1t',
    url: 'assets/track-piece-thumbnails/slope-60-hold-run1t.c15a9a99cc81.webp',
    viewId: 'side',
    width: 384,
    height: 384,
    byteSize: 4430,
    sha256: 'c15a9a99cc818fa79e463964f8ceb85e057bf90814ff2be8f354189c8322f01a',
    rendererVersion: 'bc-906-v2',
  },
  {
    descriptorId: 'slope.60.hold.run2t',
    url: 'assets/track-piece-thumbnails/slope-60-hold-run2t.40547c02d533.webp',
    viewId: 'side',
    width: 384,
    height: 384,
    byteSize: 4556,
    sha256: '40547c02d533566230d1d6f262ba3664eeb13dc36b02129409ee3dc86b1ddfeb',
    rendererVersion: 'bc-906-v2',
  },
  {
    descriptorId: 'slope.60.hold.run3t',
    url: 'assets/track-piece-thumbnails/slope-60-hold-run3t.bf0c772e14ea.webp',
    viewId: 'side',
    width: 384,
    height: 384,
    byteSize: 4592,
    sha256: 'bf0c772e14ea0bf150f9ddf8ee8341899b5515f44d23463052bdb08b4661806d',
    rendererVersion: 'bc-906-v2',
  },
  {
    descriptorId: 'slope.n60.hold.run0_5t',
    url: 'assets/track-piece-thumbnails/slope-n60-hold-run0-5t.dadd8fab6f1f.webp',
    viewId: 'side',
    width: 384,
    height: 384,
    byteSize: 3044,
    sha256: 'dadd8fab6f1f8f3fab1fbc56076bc37e6c273541beba9416f225890977b671a7',
    rendererVersion: 'bc-906-v2',
  },
  {
    descriptorId: 'slope.n60.hold.run1t',
    url: 'assets/track-piece-thumbnails/slope-n60-hold-run1t.981d029f9680.webp',
    viewId: 'side',
    width: 384,
    height: 384,
    byteSize: 3130,
    sha256: '981d029f9680721b704bfc065773b6a90263a0136574d171c1a1c759cfb6577d',
    rendererVersion: 'bc-906-v2',
  },
  {
    descriptorId: 'slope.n60.hold.run2t',
    url: 'assets/track-piece-thumbnails/slope-n60-hold-run2t.dcabfed72f91.webp',
    viewId: 'side',
    width: 384,
    height: 384,
    byteSize: 3118,
    sha256: 'dcabfed72f9193be7510702fc82c3ccf73b5a38ad483c5a8c2c7027ba2e98d25',
    rendererVersion: 'bc-906-v2',
  },
  {
    descriptorId: 'slope.n60.hold.run3t',
    url: 'assets/track-piece-thumbnails/slope-n60-hold-run3t.55ef9dae1be7.webp',
    viewId: 'side',
    width: 384,
    height: 384,
    byteSize: 3116,
    sha256: '55ef9dae1be7b6593a4964196d9237760ab0b8186b3003494c28ed0491368fdd',
    rendererVersion: 'bc-906-v2',
  },
  {
    descriptorId: 'slope.90.hold.rise0_5t',
    url: 'assets/track-piece-thumbnails/slope-90-hold-rise0-5t.99fdb45e5d11.webp',
    viewId: 'side',
    width: 384,
    height: 384,
    byteSize: 2336,
    sha256: '99fdb45e5d11df22ad9d929f458cf3fdc2b43ad7002eb30a1dafc6e37077f9bf',
    rendererVersion: 'bc-906-v2',
  },
  {
    descriptorId: 'slope.90.hold.rise1t',
    url: 'assets/track-piece-thumbnails/slope-90-hold-rise1t.4e3e938402b3.webp',
    viewId: 'side',
    width: 384,
    height: 384,
    byteSize: 2356,
    sha256: '4e3e938402b3c7c524e7f43bdc4530e21d99d7380a1e71041febaa9319a44f96',
    rendererVersion: 'bc-906-v2',
  },
  {
    descriptorId: 'slope.90.hold.rise2t',
    url: 'assets/track-piece-thumbnails/slope-90-hold-rise2t.4cfb0550af35.webp',
    viewId: 'side',
    width: 384,
    height: 384,
    byteSize: 2446,
    sha256: '4cfb0550af357f699b862bb74604133b913c24044b9811c3c23e31c30087ea89',
    rendererVersion: 'bc-906-v2',
  },
  {
    descriptorId: 'slope.90.hold.rise3t',
    url: 'assets/track-piece-thumbnails/slope-90-hold-rise3t.fa2a6c1d7c05.webp',
    viewId: 'side',
    width: 384,
    height: 384,
    byteSize: 2518,
    sha256: 'fa2a6c1d7c05240b126c891086ffb62283dcb10d11235ed7637227ee40710c4e',
    rendererVersion: 'bc-906-v2',
  },
  {
    descriptorId: 'slope.n90.hold.rise0_5t',
    url: 'assets/track-piece-thumbnails/slope-n90-hold-rise0-5t.b32b181bf2ab.webp',
    viewId: 'side',
    width: 384,
    height: 384,
    byteSize: 2246,
    sha256: 'b32b181bf2abb6a9a98d003c9c10cca71f0159588d7a26b5723ea87aaeae4839',
    rendererVersion: 'bc-906-v2',
  },
  {
    descriptorId: 'slope.n90.hold.rise1t',
    url: 'assets/track-piece-thumbnails/slope-n90-hold-rise1t.ee73a6e1add8.webp',
    viewId: 'side',
    width: 384,
    height: 384,
    byteSize: 2388,
    sha256: 'ee73a6e1add858a073dfb90bc9e39b9718e2de29209c881e9e718351515f5fcd',
    rendererVersion: 'bc-906-v2',
  },
  {
    descriptorId: 'slope.n90.hold.rise2t',
    url: 'assets/track-piece-thumbnails/slope-n90-hold-rise2t.712744a10758.webp',
    viewId: 'side',
    width: 384,
    height: 384,
    byteSize: 2494,
    sha256: '712744a10758fb44cdee3cdaf139c5c5ae29106bb55747b2994c107d6a948207',
    rendererVersion: 'bc-906-v2',
  },
  {
    descriptorId: 'slope.n90.hold.rise3t',
    url: 'assets/track-piece-thumbnails/slope-n90-hold-rise3t.aa9b99ece888.webp',
    viewId: 'side',
    width: 384,
    height: 384,
    byteSize: 2544,
    sha256: 'aa9b99ece888fa66ba689319958e90dfdfa27eb0c43527fa7d2fc172f5f408bd',
    rendererVersion: 'bc-906-v2',
  },
  {
    descriptorId: 'turn.left.45.small',
    url: 'assets/track-piece-thumbnails/turn-left-45-small.a1e73f505856.webp',
    viewId: 'top',
    width: 384,
    height: 384,
    byteSize: 7330,
    sha256: 'a1e73f5058567fce2efcc5810a380bd8b2d33ebfe8ad0f39a40655d4eb5f76ad',
    rendererVersion: 'bc-906-v2',
  },
  {
    descriptorId: 'turn.right.45.small',
    url: 'assets/track-piece-thumbnails/turn-right-45-small.2716cc6910ec.webp',
    viewId: 'top',
    width: 384,
    height: 384,
    byteSize: 9160,
    sha256: '2716cc6910ec84cff21203dc9a6faf2828db50f3078b28074ac8bc9cdad2aa5b',
    rendererVersion: 'bc-906-v2',
  },
  {
    descriptorId: 'turn.left.90.small',
    url: 'assets/track-piece-thumbnails/turn-left-90-small.231ace826648.webp',
    viewId: 'top',
    width: 384,
    height: 384,
    byteSize: 8970,
    sha256: '231ace826648814773fd572167346a3c963d0e0636b1a320ff1c59f307169301',
    rendererVersion: 'bc-906-v2',
  },
  {
    descriptorId: 'turn.right.90.small',
    url: 'assets/track-piece-thumbnails/turn-right-90-small.07ce747431e4.webp',
    viewId: 'top',
    width: 384,
    height: 384,
    byteSize: 11312,
    sha256: '07ce747431e40c01171ff7186410de7f73e413e701cdaa52c362a6eb12883113',
    rendererVersion: 'bc-906-v2',
  },
  {
    descriptorId: 'turn.left.45.medium',
    url: 'assets/track-piece-thumbnails/turn-left-45-medium.b22f7ad5596d.webp',
    viewId: 'top',
    width: 384,
    height: 384,
    byteSize: 7282,
    sha256: 'b22f7ad5596d184ef888ce2bc08a20db3c167a46f83aa1928cc6eb2a67793662',
    rendererVersion: 'bc-906-v2',
  },
  {
    descriptorId: 'turn.right.45.medium',
    url: 'assets/track-piece-thumbnails/turn-right-45-medium.3f7345fe94a0.webp',
    viewId: 'top',
    width: 384,
    height: 384,
    byteSize: 8976,
    sha256: '3f7345fe94a0fb984f16af32e42f8063fca5611b1633d513a280188b8d3ba024',
    rendererVersion: 'bc-906-v2',
  },
  {
    descriptorId: 'turn.left.90.medium',
    url: 'assets/track-piece-thumbnails/turn-left-90-medium.d284020f694d.webp',
    viewId: 'top',
    width: 384,
    height: 384,
    byteSize: 9400,
    sha256: 'd284020f694d988a2af4ef98d40c48b60f657ae38f6d1f9c75788ade70d9e6d0',
    rendererVersion: 'bc-906-v2',
  },
  {
    descriptorId: 'turn.right.90.medium',
    url: 'assets/track-piece-thumbnails/turn-right-90-medium.95c991422c18.webp',
    viewId: 'top',
    width: 384,
    height: 384,
    byteSize: 11486,
    sha256: '95c991422c18bf38a347f9485079abfaa70c372bc1a2aa3d2b4e65a3d61b6109',
    rendererVersion: 'bc-906-v2',
  },
  {
    descriptorId: 'turn.left.45.large',
    url: 'assets/track-piece-thumbnails/turn-left-45-large.14a538cbf253.webp',
    viewId: 'top',
    width: 384,
    height: 384,
    byteSize: 7098,
    sha256: '14a538cbf253ed24156bf9521a47189bd0ad24d4cd54c662d42646faeae01482',
    rendererVersion: 'bc-906-v2',
  },
  {
    descriptorId: 'turn.right.45.large',
    url: 'assets/track-piece-thumbnails/turn-right-45-large.85696d50beca.webp',
    viewId: 'top',
    width: 384,
    height: 384,
    byteSize: 8864,
    sha256: '85696d50becabf4cf239f59de13e688731d7a8abbbaca2ed8239a70df19d188b',
    rendererVersion: 'bc-906-v2',
  },
  {
    descriptorId: 'turn.left.90.large',
    url: 'assets/track-piece-thumbnails/turn-left-90-large.e904052c78c6.webp',
    viewId: 'top',
    width: 384,
    height: 384,
    byteSize: 9270,
    sha256: 'e904052c78c69eab1f12372c24f99e696d9de2cee41f8b7a28ad7a83218d22aa',
    rendererVersion: 'bc-906-v2',
  },
  {
    descriptorId: 'turn.right.90.large',
    url: 'assets/track-piece-thumbnails/turn-right-90-large.c2d3ebdeaeae.webp',
    viewId: 'top',
    width: 384,
    height: 384,
    byteSize: 11412,
    sha256: 'c2d3ebdeaeaeec35d613f4f5ae22a15df326f0432651e4c6f602a5589661e954',
    rendererVersion: 'bc-906-v2',
  },
  {
    descriptorId: 's_bend.left',
    url: 'assets/track-piece-thumbnails/s-bend-left.f411eb27a6a5.webp',
    viewId: 'top',
    width: 384,
    height: 384,
    byteSize: 6200,
    sha256: 'f411eb27a6a5c7d98b7c91c57aec4d05dc46b87b59a7d942ddbb5fd2d6748850',
    rendererVersion: 'bc-906-v2',
  },
  {
    descriptorId: 's_bend.right',
    url: 'assets/track-piece-thumbnails/s-bend-right.2246ae4791f6.webp',
    viewId: 'top',
    width: 384,
    height: 384,
    byteSize: 7350,
    sha256: '2246ae4791f634259194156520ef0f28347ac76e3d1159608c684d4e31425f60',
    rendererVersion: 'bc-906-v2',
  },
  {
    descriptorId: 'bank.level.left.1t',
    url: 'assets/track-piece-thumbnails/bank-level-left-1t.127c5d965dcc.webp',
    viewId: 'bank-transition',
    width: 384,
    height: 384,
    byteSize: 6452,
    sha256: '127c5d965dcca7d5be22b4237b8f0a863e55c448fc11f7972b30fc0e21d6bc87',
    rendererVersion: 'bc-906-v2',
  },
  {
    descriptorId: 'bank.left.level.1t',
    url: 'assets/track-piece-thumbnails/bank-left-level-1t.5f7719d9fe57.webp',
    viewId: 'bank-transition',
    width: 384,
    height: 384,
    byteSize: 6536,
    sha256: '5f7719d9fe57d16e97295fd4a435af37e96009e21b5e44e05e30eb02cdb75c69',
    rendererVersion: 'bc-906-v2',
  },
  {
    descriptorId: 'bank.level.right.1t',
    url: 'assets/track-piece-thumbnails/bank-level-right-1t.5bac0ed926c4.webp',
    viewId: 'bank-transition',
    width: 384,
    height: 384,
    byteSize: 7598,
    sha256: '5bac0ed926c4ad01d374d71ed2c8b96ffc020afdfd1bc86531889b4d56852b69',
    rendererVersion: 'bc-906-v2',
  },
  {
    descriptorId: 'bank.right.level.1t',
    url: 'assets/track-piece-thumbnails/bank-right-level-1t.6b9ca02c3083.webp',
    viewId: 'bank-transition',
    width: 384,
    height: 384,
    byteSize: 7466,
    sha256: '6b9ca02c3083d158b4258595a09636b530ad7cf46239660e8c80b17b199de521',
    rendererVersion: 'bc-906-v2',
  },
  {
    descriptorId: 'bank.level.left.2t',
    url: 'assets/track-piece-thumbnails/bank-level-left-2t.748dc3805679.webp',
    viewId: 'bank-transition',
    width: 384,
    height: 384,
    byteSize: 9954,
    sha256: '748dc38056796891a6d18259b2d5c120e000848052d0073e8043188fea94e0e8',
    rendererVersion: 'bc-906-v2',
  },
  {
    descriptorId: 'bank.left.level.2t',
    url: 'assets/track-piece-thumbnails/bank-left-level-2t.6a9618a1b5a8.webp',
    viewId: 'bank-transition',
    width: 384,
    height: 384,
    byteSize: 10154,
    sha256: '6a9618a1b5a811ddfbc3e5267bce008bacb7a58cd6e9e2481b276f3c0945ee1a',
    rendererVersion: 'bc-906-v2',
  },
  {
    descriptorId: 'bank.level.right.2t',
    url: 'assets/track-piece-thumbnails/bank-level-right-2t.2256c892f522.webp',
    viewId: 'bank-transition',
    width: 384,
    height: 384,
    byteSize: 10834,
    sha256: '2256c892f522ba2256ca543f0664c583901f37d524e75fd126368770170f5312',
    rendererVersion: 'bc-906-v2',
  },
  {
    descriptorId: 'bank.right.level.2t',
    url: 'assets/track-piece-thumbnails/bank-right-level-2t.8bc903501dc7.webp',
    viewId: 'bank-transition',
    width: 384,
    height: 384,
    byteSize: 10792,
    sha256: '8bc903501dc72d8a9c877d44e5b6feb5738f2a82d8e9a640c26633f359959c68',
    rendererVersion: 'bc-906-v2',
  },
  {
    descriptorId: 'helix.left.up',
    url: 'assets/track-piece-thumbnails/helix-left-up.7831fc4ed366.webp',
    viewId: 'helix',
    width: 384,
    height: 384,
    byteSize: 11834,
    sha256: '7831fc4ed366ca79f905a3912f99aa07557b0481e7d07e7aa8d89172359a3435',
    rendererVersion: 'bc-906-v2',
  },
  {
    descriptorId: 'helix.right.up',
    url: 'assets/track-piece-thumbnails/helix-right-up.5fba5dabb044.webp',
    viewId: 'helix',
    width: 384,
    height: 384,
    byteSize: 11828,
    sha256: '5fba5dabb0445e1102771b6a17e0d9639b4bc0c4759fe143bc139f8d43624d6e',
    rendererVersion: 'bc-906-v2',
  },
  {
    descriptorId: 'loop.left',
    url: 'assets/track-piece-thumbnails/loop-left.196daaee02f3.webp',
    viewId: 'isometric',
    width: 384,
    height: 384,
    byteSize: 11954,
    sha256: '196daaee02f3f2c2c673878e7206cf95a4f3a603751ae5ec89d09d43fd7dbb06',
    rendererVersion: 'bc-906-v2',
  },
  {
    descriptorId: 'loop.right',
    url: 'assets/track-piece-thumbnails/loop-right.505c12fecfa7.webp',
    viewId: 'isometric',
    width: 384,
    height: 384,
    byteSize: 13756,
    sha256: '505c12fecfa70b971371645aace96c038d8fdfcda2bb65d1b24ddc0dec599210',
    rendererVersion: 'bc-906-v2',
  },
  {
    descriptorId: 'roll.left',
    url: 'assets/track-piece-thumbnails/roll-left.0963a586bea7.webp',
    viewId: 'isometric',
    width: 384,
    height: 384,
    byteSize: 3216,
    sha256: '0963a586bea716344131e0aba4e515973c0fd460f9a5839cf6096480ad8083e0',
    rendererVersion: 'bc-906-v2',
  },
  {
    descriptorId: 'roll.right',
    url: 'assets/track-piece-thumbnails/roll-right.b0538a7c8138.webp',
    viewId: 'isometric',
    width: 384,
    height: 384,
    byteSize: 3194,
    sha256: 'b0538a7c8138f1bb77040ea1bdb08af9ebbff09cd17bbaac0f85b1a0418a7caa',
    rendererVersion: 'bc-906-v2',
  },
  {
    descriptorId: 'corkscrew.left',
    url: 'assets/track-piece-thumbnails/corkscrew-left.3313d20012a5.webp',
    viewId: 'isometric',
    width: 384,
    height: 384,
    byteSize: 6710,
    sha256: '3313d20012a5714c4d19e07fcbb7022fc194fc016ccfa1755dc9c9584a01f2f0',
    rendererVersion: 'bc-906-v2',
  },
  {
    descriptorId: 'corkscrew.right',
    url: 'assets/track-piece-thumbnails/corkscrew-right.cde436f8be3c.webp',
    viewId: 'isometric',
    width: 384,
    height: 384,
    byteSize: 5882,
    sha256: 'cde436f8be3c4e112a375b8d6d57200bc4481a0a588655ae7bf010b40394b147',
    rendererVersion: 'bc-906-v2',
  },
  {
    descriptorId: 'half_loop.up',
    url: 'assets/track-piece-thumbnails/half-loop-up.831475c14110.webp',
    viewId: 'isometric',
    width: 384,
    height: 384,
    byteSize: 7572,
    sha256: '831475c14110b7a7fabb15f2f06fe522565f30f3272510dd4f635d3057c572aa',
    rendererVersion: 'bc-906-v2',
  },
  {
    descriptorId: 'half_loop.down',
    url: 'assets/track-piece-thumbnails/half-loop-down.562446642168.webp',
    viewId: 'isometric',
    width: 384,
    height: 384,
    byteSize: 7524,
    sha256: '562446642168d3f907d475a7c8d308c76e4bf4a4247c3664123abb283dfaa124',
    rendererVersion: 'bc-906-v2',
  },
  {
    descriptorId: 'half_roll.left.to_inverted',
    url: 'assets/track-piece-thumbnails/half-roll-left-to-inverted.43b5d00e81e6.webp',
    viewId: 'isometric',
    width: 384,
    height: 384,
    byteSize: 5624,
    sha256: '43b5d00e81e69786801ebceec8829e1795f501feec85fa211365fbfad890a39f',
    rendererVersion: 'bc-906-v2',
  },
  {
    descriptorId: 'half_roll.right.to_inverted',
    url: 'assets/track-piece-thumbnails/half-roll-right-to-inverted.85361c04f6b4.webp',
    viewId: 'isometric',
    width: 384,
    height: 384,
    byteSize: 5644,
    sha256: '85361c04f6b4cd43fbd49213ba2c9825cb3ab8f17670ce77c19e1700f6b0356f',
    rendererVersion: 'bc-906-v2',
  },
  {
    descriptorId: 'half_roll.left.to_upright',
    url: 'assets/track-piece-thumbnails/half-roll-left-to-upright.43b5d00e81e6.webp',
    viewId: 'isometric',
    width: 384,
    height: 384,
    byteSize: 5624,
    sha256: '43b5d00e81e69786801ebceec8829e1795f501feec85fa211365fbfad890a39f',
    rendererVersion: 'bc-906-v2',
  },
  {
    descriptorId: 'half_roll.right.to_upright',
    url: 'assets/track-piece-thumbnails/half-roll-right-to-upright.85361c04f6b4.webp',
    viewId: 'isometric',
    width: 384,
    height: 384,
    byteSize: 5644,
    sha256: '85361c04f6b4cd43fbd49213ba2c9825cb3ab8f17670ce77c19e1700f6b0356f',
    rendererVersion: 'bc-906-v2',
  },
  {
    descriptorId: 'half_corkscrew.left.to_inverted',
    url: 'assets/track-piece-thumbnails/half-corkscrew-left-to-inverted.5725fd9440c9.webp',
    viewId: 'isometric',
    width: 384,
    height: 384,
    byteSize: 8928,
    sha256: '5725fd9440c98542c260fca39c70b083f580a6e1f80905a259942e1b7b26ae5f',
    rendererVersion: 'bc-906-v2',
  },
  {
    descriptorId: 'half_corkscrew.right.to_inverted',
    url: 'assets/track-piece-thumbnails/half-corkscrew-right-to-inverted.9a8cdc94a7d1.webp',
    viewId: 'isometric',
    width: 384,
    height: 384,
    byteSize: 7902,
    sha256: '9a8cdc94a7d1486d0f77567812eb0fd85079c0b9842e4ac2680c2f96cfaeb58a',
    rendererVersion: 'bc-906-v2',
  },
  {
    descriptorId: 'half_corkscrew.left.to_upright',
    url: 'assets/track-piece-thumbnails/half-corkscrew-left-to-upright.2961ad373a58.webp',
    viewId: 'isometric',
    width: 384,
    height: 384,
    byteSize: 11486,
    sha256: '2961ad373a581c83f1bf163c48ff5d029e8c95febfab3676667c7b7138d7192c',
    rendererVersion: 'bc-906-v2',
  },
  {
    descriptorId: 'half_corkscrew.right.to_upright',
    url: 'assets/track-piece-thumbnails/half-corkscrew-right-to-upright.85a304f0c9b1.webp',
    viewId: 'isometric',
    width: 384,
    height: 384,
    byteSize: 7796,
    sha256: '85a304f0c9b1a073982f1d6fbf8ffdf7a843c2e345b678363b2b027b43acc938',
    rendererVersion: 'bc-906-v2',
  },
  {
    descriptorId: 'zero_g_roll.left',
    url: 'assets/track-piece-thumbnails/zero-g-roll-left.a8db47d5f473.webp',
    viewId: 'isometric',
    width: 384,
    height: 384,
    byteSize: 4390,
    sha256: 'a8db47d5f47362089857b1ac1dd612d186c1515de9427fff7014ba02094d31a9',
    rendererVersion: 'bc-906-v2',
  },
  {
    descriptorId: 'zero_g_roll.right',
    url: 'assets/track-piece-thumbnails/zero-g-roll-right.e3dccb94fe13.webp',
    viewId: 'isometric',
    width: 384,
    height: 384,
    byteSize: 4438,
    sha256: 'e3dccb94fe1385ec3d08e52c5f256137a5b9fe3c1e09a1326b3578588a0ac3f1',
    rendererVersion: 'bc-906-v2',
  },
  {
    descriptorId: 'helix.left.down',
    url: 'assets/track-piece-thumbnails/helix-left-down.a11654d1d9ab.webp',
    viewId: 'helix',
    width: 384,
    height: 384,
    byteSize: 9670,
    sha256: 'a11654d1d9ab7168d0ef0621767ac900ed95e989d9998c77ee32f5248e36d8bf',
    rendererVersion: 'bc-906-v2',
  },
  {
    descriptorId: 'helix.right.down',
    url: 'assets/track-piece-thumbnails/helix-right-down.0a0e5d90efc9.webp',
    viewId: 'helix',
    width: 384,
    height: 384,
    byteSize: 9340,
    sha256: '0a0e5d90efc9c3136d6bb28f83d8e69b87d5e3765b8777b2d58c5a96d2543701',
    rendererVersion: 'bc-906-v2',
  },
] as const satisfies readonly TrackPieceThumbnailManifestEntry[];

export const TRACK_PIECE_THUMBNAIL_BY_DESCRIPTOR: ReadonlyMap<
  string,
  TrackPieceThumbnailManifestEntry
> = new Map(TRACK_PIECE_THUMBNAIL_MANIFEST.map((entry) => [entry.descriptorId, entry]));
